import type { OrderItem } from "app/types/common-types"

export const isFullyShippingRestricted = (orderItems: OrderItem[]) => {
    const hazmatPartnumbers = getHazmatPartNumbers(orderItems)
    return orderItems.every(({ partNumber }) => hazmatPartnumbers.includes(Number(partNumber)))
}

export const isPartiallyShippingRestricted = (orderItems: OrderItem[]) => {
    const hazmatPartnumbers = getHazmatPartNumbers(orderItems)
    const restrictedCount = hazmatPartnumbers.length
    const someHazmat = orderItems.some(({ partNumber }) => hazmatPartnumbers.includes(Number(partNumber)))
    const moreOrderItemsThanHazmat = restrictedCount > 0 && restrictedCount < orderItems.length
    return someHazmat && moreOrderItemsThanHazmat
}

export const getHazmatPartNumbers = (orderItems: OrderItem[]) => {
    const usableShippingMode = orderItems[0]?.usableShippingMode
    const notRestricted = !usableShippingMode?.length || usableShippingMode.some(({ xiush_available }) => xiush_available !== 'false')
    if (notRestricted) return []
    //usableShippingMode is duplicated in each orderItem
    let { xiush_limitationMatches = [] } = usableShippingMode[0]
    //limitationMatches can be a json string
    if (typeof xiush_limitationMatches === 'string') {
        try {
            xiush_limitationMatches = JSON.parse(xiush_limitationMatches)
        } catch {}
    }

    return xiush_limitationMatches.map(({ type, gtin }) => type === 'HAZMAT' && Number(gtin))
}
